export const MENU_SELECT_ITEMS = [
  { value: "TRM_RULE", label: "Rule" },
  { value: "MONITORING_QUEUE", label: "Monitoring queue" },
  { value: "REPORTS", label: "Reports" },
];

export const ACTIVITY_SELECT_ITEMS = [
  { value: "CREATE_RULE", label: "Create rule" },
  { value: "UPDATE_RULE", label: "Update rule" },
  { value: "UPDATE_FLAG", label: "Update flag" },
  { value: "ESCALATE_FLAG", label: "Escalate flag" },
  {
    value: "GENERATED_SINGLE_REPORT",
    label: "Generate single report",
  },
  { value: "REPORT_EXPORT", label: "Report export" },
  { value: "GET_RULE", label: "Get rule" },
  { value: "DELETE_DATA_FIELD", label: "Delete data field" },
  {
    value: "UPDATE_DISPLAYED_ENTITY",
    label: "Update displayed entity",
  },
  { value: "UPDATE_RULE_STATUS", label: "Update rule status" },
  { value: "UPDATE_RULE_NAME", label: "Update rule name" },
  { value: "GET_FLAGS", label: "Get flags" },
  { value: "GET_FLAG_DETAILS", label: "Get flag details" },
  { value: "UPDATE_FLAG_STATUS", label: "Update flag status" },
  { value: "SINGLE_REPORT", label: "Single report" },
  { value: "MULTI_REPORT", label: "Multy report" },
  { value: "MONITORING_REPORT", label: "Monitoring report" },
  { value: "DAILY_REPORT", label: "Daily report" },
];

export const ROLE_SELECT_ITEMS = [
  { value: "ADMIN", label: "Admin" },
  { value: "AML_CORDINATOR", label: "AML coordinator" },
  { value: "AML_MANAGER", label: "AML manager" },
  { value: "AUDITOR", label: "Auditor" },
];

